import React from 'react';
import "./InsightDetailPage.css";
import NavBar from "../NavBar";
import Footer from "../Footer";
import InsightsDetails from '../../Common/InsightsDetails';
//import {InSights_Detail} from "../../data";


// function App() {
//   return <X07InsightsPageDETAILSMobile {...x07InsightsPageDETAILSMobileData} />;
// }

// export default App;

export default function X07InsightsPageDETAILSMobile(props) {
  // const {
  //   bbmp,
  //   rectangle76,
  //   text255,
  //   text256,
  //   image9,
  //   text257,
  //   spanText,
  //   spanText2,
  //   spanText3,
  //   frame145Props,
  //   //group2122Props,
  // } = props;

  return (
    <div className="idpm-container-center-horizontal">
      <div className="idpm-x07-insights-page-details-mobile screen">
        {/* <Frame145 group86Props={frame145Props.group86Props} iconMenuProps={frame145Props.iconMenuProps} /> */}
        <NavBar/>
        <InsightsDetails {...props}/>
        {/* <h1 className="idpm-title idpm-valign-text-middle idpm-typographyheadlineh4-extrabold-24">{bbmp}</h1> */}
        {/* <img className="idpm-rectangle-76" src={rectangle76} /> */}
        {/* <img className="idpm-rectangle-76" src={InSights_Detail.BBMP} />
        <p className="idpm-text-3 idpm-typography-body-smalltext-14-regular">{text255}</p>
        <div className="idpm-text-4 idpm-valign-text-middle idpm-typographyheadlineh4-extrabold-24">{text256}</div> */}
        {/* <img className="idpm-image-9" src={image9} /> */}
        {/* <img className="idpm-image-9" src={InSights_Detail.BbmpPlan} />
        <p className="idpm-text-5 idpm-typographybody16-regular">{text257}</p>
        <p className="idpm-text-6 idpm-valign-text-middle idpm-overpass-semi-bold-white-16px2">
          <span>
            <span className="idpm-overpass-semi-bold-mahogany-16px">{spanText}</span>
            <span className="idpm-span1 ">{spanText2}</span>
            <span className="idpm-overpass-semi-bold-mahogany-16px">{spanText3}</span>
          </span>
        </p> */}
        {/* <Group2122
          group862Props={group2122Props.group862Props}
          group872Props={group2122Props.group872Props}
          group322Props={group2122Props.group322Props}
          frame5Props={group2122Props.frame5Props}
        /> */}
        <Footer />
      </div>
    </div>
  );
}


function Frame145(props) {
  const { group86Props, iconMenuProps } = props;

  return (
    <div className="idpm-frame-145">
      <Group86 group85={group86Props.group85} whiteProps={group86Props.whiteProps} />
      <IconMenu vector2={iconMenuProps.vector2} vector3={iconMenuProps.vector3} />
    </div>
  );
}


function Group86(props) {
  const { group85, whiteProps } = props;

  return (
    <div className="idpm-group-86">
      <White src={whiteProps.src} />
      <img className="idpm-group-85" src={group85} />
    </div>
  );
}


function White(props) {
  const { src } = props;

  return (
    <div className="idpm-white">
      <img className="idpm-vector" src={src} />
    </div>
  );
}


function IconMenu(props) {
  const { vector2, vector3 } = props;

  return (
    <div className="idpm-icon-menu">
      <img
        className="idpm-vector-2"
        src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-159@2x.svg"
      />
      <img className="idpm-vector-1" src={vector2} />
      <img className="idpm-vector-1" src={vector3} />
    </div>
  );
}


// function Group2122(props) {
//   const { group862Props, group872Props, group322Props, frame5Props } = props;

//   return (
//     <div className="idpm-group-212">
//       <div className="idpm-flex-row">
//         <Group8622 group85={group862Props.group85} />
//         <Group872
//           facebookAppSymbolProps={group872Props.facebookAppSymbolProps}
//           facebookAppSymbolProps2={group872Props.facebookAppSymbolProps2}
//           twitterProps={group872Props.twitterProps}
//         />
//       </div>
//       <Group322 {...group322Props} />
//       <Frame5
//         quickLinks={frame5Props.quickLinks}
//         frame140Props={frame5Props.frame140Props}
//         frame1402Props={frame5Props.frame1402Props}
//         frame1403Props={frame5Props.frame1403Props}
//       />
//     </div>
//   );
// }


function Group8622(props) {
  const { group85 } = props;

  return (
    <div className="idpm-group-86-1">
      <div className="idpm-white-1">
        <img
          className="idpm-vector-3"
          src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-148@2x.svg"
        />
      </div>
      <img className="idpm-group-85-1" src={group85} />
    </div>
  );
}


function Group872(props) {
  const { facebookAppSymbolProps, facebookAppSymbolProps2, twitterProps } = props;

  return (
    <div className="idpm-group-87">
      <FacebookAppSymbol src={facebookAppSymbolProps.src} />
      <Instagram2 overlapGroup1={facebookAppSymbolProps2.overlapGroup1} vector2={facebookAppSymbolProps2.vector2} />
      <Twitter src={twitterProps.src} />
    </div>
  );
}


function FacebookAppSymbol(props) {
  const { src } = props;

  return (
    <div className="idpm-facebook-app-symbol">
      <img className="idpm-f-1" src={src} />
    </div>
  );
}


function Instagram2(props) {
  const { overlapGroup1, vector2 } = props;

  return (
    <div className="idpm-instagram">
      <div className="idpm-overlap-group" style={{ backgroundImage: `url(${overlapGroup1})` }}>
        <img
          className="idpm-vector-4"
          src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-18@2x.svg"
        />
        <img className="idpm-vector-5" src={vector2} />
      </div>
    </div>
  );
}


function Twitter(props) {
  const { src } = props;

  return (
    <div className="idpm-twitter">
      <img className="idpm-vector-6" src={src} />
    </div>
  );
}


function Group322(props) {
  const { place, overlapGroup, phone, overlapGroup1, vector2, text165, text164, contactWebuildCom } = props;

  return (
    <div className="idpm-group-32">
      <div className="idpm-place idpm-valign-text-middle idpm-typographyheadlineh5-extrabold-20">{place}</div>
      <div className="idpm-flex-row-1">
        <div className="idpm-flex-col">
          <div className="idpm-map-pin-1">
            <div className="idpm-overlap-group-1" style={{ backgroundImage: `url(${overlapGroup})` }}>
              <img
                className="idpm-vector-7"
                src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-21@2x.svg"
              />
            </div>
          </div>
          <div className="idpm-phone" style={{ backgroundImage: `url(${phone})` }}></div>
          <div className="idpm-mail">
            <div className="idpm-overlap-group1" style={{ backgroundImage: `url(${overlapGroup1})` }}>
              <img className="idpm-vector-8" src={vector2} />
            </div>
          </div>
        </div>
        <div className="idpm-flex-col-1">
          <p className="idpm-text-2 idpm-typography-body-smalltext-14-regular">{text165}</p>
          <div className="idpm-flex-col-item idpm-valign-text-middle idpm-typography-body-smalltext-14-regular">{text164}</div>
          <div className="idpm-flex-col-item idpm-valign-text-middle idpm-typography-body-smalltext-14-regular">
            {contactWebuildCom}
          </div>
        </div>
      </div>
    </div>
  );
}


function Frame5(props) {
  const { quickLinks, frame140Props, frame1402Props, frame1403Props } = props;

  return (
    <div className="idpm-frame-5">
      <div className="idpm-quick-links idpm-valign-text-middle idpm-typographyheadlineh5-extrabold-20">{quickLinks}</div>
      <div className="idpm-frame-4">
        <Frame140 aboutUs={frame140Props.aboutUs} projects={frame140Props.projects} />
        <Frame140
          aboutUs={frame1402Props.aboutUs}
          projects={frame1402Props.projects}
          className={frame1402Props.className}
        />
        <Frame140
          aboutUs={frame1403Props.aboutUs}
          projects={frame1403Props.projects}
          className={frame1403Props.className}
        />
      </div>
    </div>
  );
}


function Frame140(props) {
  const { aboutUs, projects, className } = props;

  return (
    <div className={`idpm-frame-140 ${className || ""}`}>
      <div className="idpm-about-us idpm-valign-text-middle idpm-typographybody16-regular">{aboutUs}</div>
      <div className="idpm-projects idpm-valign-text-middle idpm-typographybody16-regular">{projects}</div>
    </div>
  );
}

const whiteData = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-98@2x.svg",
};

const group86Data = {
    group85: "https://raw.githubusercontent.com/shiddugmail/smk-images/cddd5118ab9b721fb3fcb416b435f6886e587deb/WebuilddLogo.svg",
    whiteProps: whiteData,
};

const iconMenuData = {
    vector2: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-159@2x.svg",
    vector3: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-159@2x.svg",
};

const frame145Data = {
    group86Props: group86Data,
    iconMenuProps: iconMenuData,
};

const group8622Data = {
    group85: "https://raw.githubusercontent.com/shiddugmail/smk-images/cddd5118ab9b721fb3fcb416b435f6886e587deb/Webuildd-Logo-White.svg",
};

const facebookAppSymbolData = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/f-1-11@2x.svg",
};

const instagram2Data = {
    overlapGroup1: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-215@2x.svg",
    vector2: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-19@2x.svg",
};

const twitterData = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-218@2x.svg",
};

const group872Data = {
    facebookAppSymbolProps: facebookAppSymbolData,
    facebookAppSymbolProps2: instagram2Data,
    twitterProps: twitterData,
};

const group322Data = {
    place: "Contact",
    overlapGroup: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-20@2x.svg",
    phone: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-212@2x.svg",
    overlapGroup1: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-213@2x.svg",
    vector2: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-214@2x.svg",
    text165: "Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint.",
    text164: "+91 8976535221, +91 8755645342",
    contactWebuildCom: "contact@webuild.com",
};

const frame140Data = {
    aboutUs: "About Us",
    projects: "Projects",
};

const frame1402Data = {
    aboutUs: "Gallery",
    projects: "Knowledge Transfer",
    className: "idpm-frame-14-1",
};

const frame1403Data = {
    aboutUs: "Blogs",
    projects: "FAQ’s",
    className: "idpm-frame-14",
};

const frame5Data = {
    quickLinks: "Quick Links",
    frame140Props: frame140Data,
    frame1402Props: frame1402Data,
    frame1403Props: frame1403Data,
};

// const group2122Data = {
//     group862Props: group8622Data,
//     group872Props: group872Data,
//     group322Props: group322Data,
//     frame5Props: frame5Data,
// };

const x07InsightsPageDETAILSMobileData = {
    bbmp: "BBMP",
    rectangle76: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-76@2x.png",
    text255: "The Bruhat Bengaluru Mahanagara Palike or the BBMP is the authority managing the innumerable infrastructure and civic amenities in Greater Bengaluru. Therefore, getting clearance and approval from the BBMP before implementing the building construction is a crucial step. The BBMP authorities have the power to demolish the building already constructed or levy a huge price as a penalty for illegal construction under its jurisdiction.   However, you can be guaranteed that by following the right procedure with the submission of appropriate documents and paying the prescribed fee, the verification will be done by the concerned BBMP authorities and you will have all your documents approved and clearance within a span of 30 days.",
    text256: "How to submit building plan approval application?",
    image9: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/image-9-1@2x.png",
    text257: <ul><li>The application forms for approval can be downloaded from the official website: ___ and submitted online or offline.<br /></li><li>The choice of forms and the authorized officer to sanction the application is dependent on the size of the building plan. The different forms are attached for your perusal to give you better clarity on the terms and details asked in the set documents.<br /></li><li>By duly filling in the suitable application form according to your building size and submitting the following original documents along will enable a hassle-free process</li></ul>,
    spanText: "Latest BBMP Khata Certificate",
    spanText2: <> <br /></>,
    spanText3: <>Latest Khata Extract<br />Latest Tax Paid Receipt</>,
    frame145Props: frame145Data,
    //group2122Props: group2122Data,
};

